<ion-header
  [ngClass]="{'logged-in': this.isLoggedIn == true, 'lang-es': this.currentLang == 'es', 'lang-en': this.currentLang == 'en'}">
  <ion-toolbar class="nav-toolbar">
    <ion-buttons slot="secondary">
      <div class="mobile-collapse">
        <ion-button [hidden]="opt?.hidden" [routerLink]="opt?.path" routerLinkActive="active"
          [routerLinkActiveOptions]="this.routerMatchOpts" *ngFor="let opt of leftOptions" class="nav-button">
          {{opt.label | translate}}
        </ion-button>
      </div>
    </ion-buttons>
    <ion-buttons slot="primary">
      <div class="mobile-collapse">
        <ion-button [hidden]="opt?.hidden" [routerLink]="opt?.path" routerLinkActive="active"
          [routerLinkActiveOptions]="this.routerMatchOpts" *ngFor="let opt of rightOptions" class="nav-button">
          {{opt.label | translate}}
        </ion-button>
      </div>
    </ion-buttons>
    <ion-buttons slot="start">
      <ion-menu-button class="desktop-collapse" menu="main-menu"></ion-menu-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <div class="flex ion-justify-content-end" *ngIf="this.isLoggedIn === true">
        <ion-button type="button" (click)="this.launchPopover($event);" class="username">
          <div class="user-message">
            <span class="username-link">{{user?.username}}</span>
          </div>
          <div class="user-icon">
            <ion-icon name="person-circle-outline"></ion-icon>
          </div>
          <ion-icon slot="end" name="chevron-down-outline"></ion-icon>
        </ion-button>
      </div>
    </ion-buttons>
    <ion-title class="site-title">
      <a routerLink="/">
        <img src="assets/images/toro-logo-cropped.gif" />
      </a>
    </ion-title>
  </ion-toolbar>
</ion-header>
